import React, { Component } from "react";
import './navbar.css';
import logo from './spn.png';

class MyNavbar extends Component {
    constructor(props) {
        super(props);
    }

    toggleNav = (event) => {
        let navbar = document.getElementById("nav");
        if(navbar.classList.contains("dropdown-active")){
            navbar.classList.remove("dropdown-active");
        }
        else{
            navbar.classList.add("dropdown-active");
        }
    }


    render() {
        return (
            <div id="nav-wrapper">
                <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,300,0,200" />
                <ul id="nav">
                    <div className="nav-toggle icon-container">
                        <div className="iconWrapper" onClick={this.toggleNav}>
                            <span className="material-symbols-outlined">list</span>
                        </div>
                    </div>
                    <li><img src={logo}></img></li>
                    <li><a className="nav" href="#">Home</a></li>
                    <li><a className="nav" href="#socialRoot">Social Media</a></li>
                    <li><a className="nav" href="#contactRoot">Kontakt</a></li>
                    <li><a className="nav" href="#impressum">Impressum</a></li>
                </ul>
            </div>
        );
    }
}
export default MyNavbar; 